import { render, staticRenderFns } from "./EntityDisplay.vue?vue&type=template&id=3c6df0b9&scoped=true&lang=pug"
import script from "./EntityDisplay.vue?vue&type=script&lang=js"
export * from "./EntityDisplay.vue?vue&type=script&lang=js"
import style0 from "./EntityDisplay.vue?vue&type=style&index=0&id=3c6df0b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6df0b9",
  null
  
)

export default component.exports